import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare /hod redirects to /hod/dashboard so the URL bar always shows
// the page they're actually on.
export const Route = createFileRoute('/hod/')({
  beforeLoad: () => {
    throw redirect({ to: '/hod/dashboard' })
  },
})
